<template>
  <div id="app" class="h-full">
    <header class="fixed z-50 flex justify-between p-4 text-lg w-full">
      <div>
        <transition name="fade" mode="out-in">
            <router-link v-if="$route.name !== 'home'" class="logo" :to="{ name: 'home' }">
                <img class="h-16" :src="'/public/Calypso_Logo-' + Math.floor(1 + Math.random() * 3) + '.svg'" alt="Calypso Mahieu">
            </router-link>
        </transition>
      </div>
      <navigation></navigation>
    </header>
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Navigation from "@/components/Navigation.vue";

export default {
  name: "App",
  metaInfo() {
    return {
      titleTemplate: "Calypso Mahieu" + " %s",
    };
  },
  components: {
    Navigation,
  },
  computed: mapState(["site"]),
  created() {
    this.$store.dispatch("loadSite");
    this.$store.dispatch("loadHome");
  },
};
</script>
